import { useState } from "react";
import { ToastProps } from "./toast.types";

type UseToastType = {
  openToast: (toastPropsArg: ToastProps) => void;
  toastProps: ToastProps;
  closeToast: () => void;
};
/**
 * Useful when the developer wants to programmatically send props to Toast.
 * Refer toastTabPanel story for usage details.
 */
export const useToast = (
  useToastProps: Omit<ToastProps, "onClose">
): UseToastType => {
  const [toastProps, setToastProps] = useState<ToastProps>({
    ...useToastProps,
    open: false,
    onClose: (): void => closeToast(),
  });

  const closeToast = (): void => {
    const { open, ...toastPropsCopy } = toastProps;
    setToastProps({ open: false, ...toastPropsCopy });
  };

  const openToast = (toastPropsArg: ToastProps): void => {
    const { open, ...toastPropsCopy } = Object.assign(
      {},
      toastProps,
      toastPropsArg
    );
    setToastProps({ open: true, ...toastPropsCopy });
  };

  return { toastProps, openToast, closeToast };
};
